.TreeNode {
  list-style-type: none;
}

.Twistie {
  width: 16px;
  height: 16px;
  margin-right: 4px;

  &:hover {
    cursor: pointer;
  }
}
